<template>
  <div>
    <v-row class="desposite-dashboadpage Liabilities-page account-dashboard">
      <v-col xs="12" md="12">
        <v-row class="head-box">
          <v-col xs="8" md="8">
            <ul class="breadcrumbs-list">
              <a @click="backButton1"><li>KeepSafe</li></a>
              <a @click="backButton2"><li>&nbsp;>&nbsp;My WILL</li></a>
              <li>&nbsp;>&nbsp;Latest Will</li>
            </ul>
            <div class="head-text">
              <h1>My WILL</h1>
            </div>
          </v-col>
          <v-col xs="4" md="4">
            <div class="right-sidetop-box">
              <div class="select-box">
                <v-card>
                  <v-select
                    :items="member_items"
                    :v-model="member_name"
                    item-value="id"
                    item-text="name"
                    chips
                    label="All Users"
                    @change="refreshDashboard($event)"
                  ></v-select>
                </v-card>
              </div>
              <div class="add-btn" v-if="allow_user_activity == 'yes'">
                <v-btn class="orange-btn btn" @click="subCategory">
                  ADD NEW
                </v-btn>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-card class="tab-card bg-dot-img">
      <v-tabs v-model="tab">
        <v-tabs-slider></v-tabs-slider>
        <v-tab href="#tab-1" class="tabs-box"> Latest Will </v-tab>
        <v-tab href="#tab-2" class="tabs-box"> Previous Will </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab" class="tabs-content">
        <v-tab-item value="tab-1"> <div>JGRIR</div> </v-tab-item>
        <v-tab-item value="tab-2"> dfgh </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>
<script>
export default {
  components: {},
  data: () => ({
    three_dots: process.env.VUE_APP_ROOT_ICONS_URL + 'three_dots.png',
    edit_pic: process.env.VUE_APP_ROOT_ICONS_URL + 'edit.png',
    delete_pic: process.env.VUE_APP_ROOT_ICONS_URL + 'delete.png',
    currentDate: new Date().setDate(new Date().getDate()),
    total: '',
    allow_user_activity: localStorage.getItem('allow_user_activity'),
  }),
};
</script>
